module.exports = __webpack_public_path__ + "static/media/business-min.1f9f684d.jpg";